import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9082 15.2451C12.8828 15.2481 12.8574 15.2499 12.8326 15.2499C12.5324 15.2499 12.272 15.0264 12.2339 14.7207C11.9572 12.5076 10.2559 11.0208 7.99993 11.0208C5.74398 11.0208 4.04266 12.5076 3.76595 14.7207C3.72426 15.0518 3.41976 15.2874 3.0917 15.2451C2.76062 15.204 2.5256 14.9019 2.56729 14.5708C2.91771 11.7693 5.1513 9.81245 7.99993 9.81245C10.8486 9.81245 13.0828 11.7693 13.4326 14.5708C13.4736 14.9019 13.2392 15.204 12.9082 15.2451ZM3.4687 4.97914C3.4687 4.64565 3.73937 4.37498 4.07287 4.37498H4.37495V4.0729C4.37495 2.24047 5.86542 0.75 7.69785 0.75H8.30201C10.1344 0.75 11.6249 2.24047 11.6249 4.0729V4.37498H11.927C12.2605 4.37498 12.5312 4.64565 12.5312 4.97914C12.5312 5.31264 12.2605 5.58331 11.927 5.58331H11.6249C11.6249 7.58248 9.9991 9.20829 7.99993 9.20829C6.00075 9.20829 4.37495 7.58248 4.37495 5.58331H4.07287C3.73937 5.58331 3.4687 5.31264 3.4687 4.97914ZM10.4166 5.58331H5.58327C5.58327 6.91609 6.66714 7.99996 7.99993 7.99996C9.33271 7.99996 10.4166 6.91609 10.4166 5.58331ZM5.58327 4.37498H10.4166V4.0729C10.4166 3.00957 9.62754 2.12689 8.60409 1.98008V3.16665C8.60409 3.50015 8.33343 3.77082 7.99993 3.77082C7.66643 3.77082 7.39576 3.50015 7.39576 3.16665V1.98008C6.37231 2.12689 5.58327 3.00957 5.58327 4.0729V4.37498Z"
      fill="#151718"
    />
  </svg>
);

const CrewsIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default CrewsIcon;
